export default "__VITE_ASSET__B4n_gWCp__"